import { formatDuration } from '../../../../lib/dateUtils';
import { downloadCsv, rowsToCsv } from '../../../creatives/data/csv';
import type { CompetitionCreativesData } from './api';

export { downloadCsv };

export function competitionCreativesToCsv(data: CompetitionCreativesData): string {
  const header = [
    'Creative ID',
    'Competitor',
    'Network',
    'Type',
    'Format',
    'Duration',
    'Days Running',
    'First Seen',
    'Last Seen',
    'Tagged',
  ];
  const rows = data.creatives.map((creative) => [
    creative.creativeId,
    creative.competitorName ?? '',
    creative.network ?? '',
    creative.creativeType ?? '',
    creative.format ?? '',
    formatDuration(creative.duration) ?? '',
    creative.activeDays === null ? '' : String(creative.activeDays),
    creative.firstSeenDate ?? '',
    creative.lastSeenDate ?? '',
    creative.tagged ? 'Yes' : 'No',
  ]);
  return rowsToCsv([header, ...rows]);
}
